import { DailyCheckInPanel } from '@repo/ui'
import { useMemo } from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { useDailyCheckInCountdown } from '../../hooks/useDailyCheckInCountdown'
import { useDailyCheckInItems } from '../../hooks/useDailyCheckInItems'
import { createCheckInItemCta } from '../../factories/createCheckInItemCta'
import { useGetCurrentCheckInStep } from '../../store'
import { pickActiveItemIndex } from '../../utils/pickActiveItemIndex'
import { indexToStep } from '../../utils/indexToStep'

export function DailyCheckInPanelWrapper() {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const currentStep = useGetCurrentCheckInStep()
  const items = useDailyCheckInItems(currentStep)
  const { targetDate, countdownType, isActive } = useDailyCheckInCountdown()

  // Determine the countdown prefix based on type
  const countdownPrefix = countdownType === 'bet' ? t('Place bet within') : t('Return after')

  const itemsWithCta = useMemo(
    () =>
      items.map((item) => ({
        ...item,
        cta: createCheckInItemCta(item.status, t)
      })),
    [items, t]
  )

  const activeItemIndex = useMemo(() => {
    return pickActiveItemIndex(itemsWithCta, currentStep)
  }, [itemsWithCta, currentStep])

  return (
    <DailyCheckInPanel
      bgImageUrl="assets/bg/checkin.webp"
      countdown={isActive ? targetDate : undefined}
      countdownPrefix={countdownPrefix}
      headerInfo={t(
        'Place a valid bet to check-in and receive a one-time use multiplier boost on your next bet'
      )}
      headerTag={t('Day {{day}}', { day: currentStep })}
      headerTitle={t('Daily Check-in')}
      highlightedStep={indexToStep(activeItemIndex)}
      items={itemsWithCta}
    />
  )
}
